"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNotFoundError = exports.UserError = void 0;
class UserError extends Error {
    constructor({ message = "An unexpected error ocurred", capture = true, }) {
        super(message);
        this.capture = capture;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, UserError.prototype);
    }
}
exports.UserError = UserError;
class PageNotFoundError extends Error {
    constructor({ message = "The page you are looking for does not exist.", fallbackUrl = "/", fallbackMessage = "Return Home", }) {
        super(message);
        this.fallbackUrl = fallbackUrl;
        this.fallbackMessage = fallbackMessage;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, PageNotFoundError.prototype);
    }
}
exports.PageNotFoundError = PageNotFoundError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3JUeXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvZXJyb3JzL0Vycm9yVHlwZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVNBLE1BQWEsU0FBVSxTQUFRLEtBQUs7SUFHbEMsWUFBWSxFQUNWLE9BQU8sR0FBRyw2QkFBNkIsRUFDdkMsT0FBTyxHQUFHLElBQUksR0FDRztRQUNqQixLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDZixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixnQ0FBZ0M7UUFDaEMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQ25ELENBQUM7Q0FDRjtBQVpELDhCQVlDO0FBV0QsTUFBYSxpQkFBa0IsU0FBUSxLQUFLO0lBSTFDLFlBQVksRUFDVixPQUFPLEdBQUcsOENBQThDLEVBQ3hELFdBQVcsR0FBRyxHQUFHLEVBQ2pCLGVBQWUsR0FBRyxhQUFhLEdBQ047UUFDekIsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ2YsSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7UUFDL0IsSUFBSSxDQUFDLGVBQWUsR0FBRyxlQUFlLENBQUM7UUFDdkMsZ0NBQWdDO1FBQ2hDLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLGlCQUFpQixDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQzNELENBQUM7Q0FDRjtBQWZELDhDQWVDIn0=